module.exports = __webpack_public_path__ + "img/lisa.f21433f6.svg";